<template>
  <v-hover v-slot:default="{ hover }">
    <div class="py-1">
      <v-row no-gutters align="start">
        <v-col cols="auto" class="pr-2">
          <v-icon large color="grey">mdi-file-link-outline</v-icon>
        </v-col>
        <v-col>
          <v-row no-gutters align="center">
            <span class="text-body-2 font-weight-medium mr-1">{{ linkedDocument.author }}</span>
            <v-spacer />
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on" @click="edit">mdi-pencil</v-icon>
              </template>
              <span>{{ $t('Edit') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small color="red" class="ml-1" v-on="on" @click="unlink">
                  mdi-link-variant-off
                </v-icon>
              </template>
              <span>{{ $t('Site.LinkedDocuments.Titles.Unlink') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small class="ml-1" v-on="on" @click="preview">mdi-eye-outline</v-icon>
              </template>
              <span>{{ $t('Preview') }}</span>
            </v-tooltip>
            <span class="ml-2 text-caption grey--text">{{ getDate(linkedDocument.linkDate) }}</span>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <span class="text-body-2">{{ linkedDocument.description }}</span>
              <div class="text-caption grey--text">ID {{ linkedDocument.linkedDocumentId }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-1" />
    </div>
  </v-hover>
</template>

<script>
import Utils from '@/ecm/common/Utils';
export default {
    name: 'LinkedDocumentItem',
    props: {
        linkedDocument: {
            type: Object,
        },
    },
    methods: {
        edit() {
            this.$emit('on-edit-linked-document', this.linkedDocument);
        },
        unlink() {
            this.$emit('on-unlink-document', this.linkedDocument);
        },
        preview() {
            this.$emit('on-display-linked-document', this.linkedDocument);
        },
        getDate() {
            return Utils.date.toUserFormatFromDateTimeString(this.linkedDocument.linkDate);
        },
    },
};
</script>
<style>
.linked-document-id_text {
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
}
</style>